var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewBookings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 1.75C6.30626 1.75 6.85003 1.91495 7.31254 2.22399C7.77505 2.53303 8.13554 2.97229 8.34841 3.4862C8.56128 4.00012 8.61698 4.56562 8.50846 5.11119C8.39994 5.65676 8.13207 6.1579 7.73874 6.55124C7.3454 6.94457 6.84426 7.21244 6.29869 7.32096C5.75312 7.42948 5.18762 7.37378 4.6737 7.16091C4.15979 6.94804 3.72053 6.58755 3.41149 6.12504C3.10245 5.66253 2.9375 5.11876 2.9375 4.5625C2.9375 3.81658 3.23382 3.10121 3.76126 2.57376C4.28871 2.04632 5.00408 1.75 5.75 1.75ZM5.75 0.625C4.97124 0.625 4.20996 0.85593 3.56244 1.28859C2.91492 1.72125 2.41024 2.3362 2.11222 3.05568C1.8142 3.77517 1.73623 4.56687 1.88816 5.33067C2.04009 6.09447 2.4151 6.79606 2.96577 7.34673C3.51644 7.8974 4.21803 8.27241 4.98183 8.42434C5.74563 8.57627 6.53733 8.4983 7.25682 8.20028C7.9763 7.90226 8.59125 7.39758 9.02391 6.75006C9.45657 6.10254 9.6875 5.34126 9.6875 4.5625C9.6875 3.51821 9.27266 2.51669 8.53423 1.77827C7.79581 1.03984 6.79429 0.625 5.75 0.625Z",
    fill: "#F2F4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 16.375H10.25V13.5625C10.25 12.8166 9.95368 12.1012 9.42624 11.5738C8.89879 11.0463 8.18342 10.75 7.4375 10.75H4.0625C3.31658 10.75 2.60121 11.0463 2.07376 11.5738C1.54632 12.1012 1.25 12.8166 1.25 13.5625V16.375H0.125V13.5625C0.125 12.5182 0.539843 11.5167 1.27827 10.7783C2.01669 10.0398 3.01821 9.625 4.0625 9.625H7.4375C8.48179 9.625 9.48331 10.0398 10.2217 10.7783C10.9602 11.5167 11.375 12.5182 11.375 13.5625V16.375Z",
    fill: "#F2F4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.75H11.375V2.875H17V1.75Z",
    fill: "#F2F4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.5625H11.375V5.6875H17V4.5625Z",
    fill: "#F2F4F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.375H11.375V8.5H17V7.375Z",
    fill: "#F2F4F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBookings);
export default __webpack_public_path__ + "static/media/view_bookings.8d15b35b6c69ad50db14634e20828723.svg";
export { ForwardRef as ReactComponent };